import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d5a520a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "graph-builder-card-title-box" }

import MultiChartV3 from '@/components/charts/multi-chart-v3.vue';
import GraphCardActionsV3 from '@/components/Common/GraphCardActionsV3.vue';
import GraphCardHeaders from '@/components/Common/GraphCardHeaders.vue';
import RexCardV3 from '@/rex-components/RexCardV3.vue';
import { useGraphData } from '@/components/Common/useGraphData';
import { useGraphActions } from '@/components/Common/useGraphActions';
import { useStoreData } from '@/components/Common/useStoreData';
import { notificationError } from '@/utils/notification';
import { useI18n } from 'vue-i18n';
import {
  GetChartOptionsParamType,
  GraphTypes,
  GraphTypesEnum,
  ChartTypes,
  ParamsType,
  ChartTypesEnum,
  HeaderType,
  Aggregation,
} from '@/components/Common/graph.types';
import {
  respFormatter,
  getChartOptionsData,
  lineChartOptionsValues,
} from '@/components/Common/graph.config';
import { computed, ref, watch } from 'vue';

interface Props {
  title?: string;
  queryName: string;
  params?: ParamsType;
  chartOptionsData?: GetChartOptionsParamType;
  graphType?: GraphTypes;
  type?: ChartTypes;
  header?: HeaderType;
  metricName: string;
  serviceName: string;
  axisLabels: { x: string; y: string };
  aggregation?: Aggregation;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GraphBuilderV3',
  props: {
    title: { default: '' },
    queryName: {},
    params: { default: () => ({
    condition: {
      name: '',
      entity: {},
    },
    duration: {},
  }) },
    chartOptionsData: { default: () => lineChartOptionsValues },
    graphType: { default: GraphTypesEnum.LINE_CHART },
    type: { default: ChartTypesEnum.RANGE_AREA },
    header: { default: () => ({}) },
    metricName: {},
    serviceName: {},
    axisLabels: {},
    aggregation: { default: () => ({ req: false }) }
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

const { getDurationTime, isForecastEnable } = useStoreData();

const graphType = ref(props.graphType);
const aggregation = ref(props.aggregation);

const { data, isLoading, error, options, makegraphQLCall, headerValues } =
  useGraphData(
    props.queryName,
    props.params,
    getChartOptionsData(graphType.value),
    graphType,
    props.axisLabels,
    aggregation,
  );

makegraphQLCall(props.queryName, props.params, respFormatter(graphType.value));

watch([error], () => {
  if (error) {
    notificationError(error.value?.message || t('errWhileFetchingData'));
  }
});

watch([() => props.graphType, getDurationTime, () => props.serviceName], () => {
  graphType.value = props.graphType;
  makegraphQLCall(
    props.queryName,
    props.params,
    respFormatter(graphType.value),
  );
});

const multiChart: any = ref(null);

const displayExpand = computed(() => {
  return graphType.value === GraphTypesEnum.FORECAST_CHART;
});

const { handleZoomIn, handleZoomOut, handleReset } = useGraphActions(
  multiChart,
  graphType,
);

return (_ctx: any,_cache: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RexCardV3, {
      loading: _unref(isLoading),
      headStyle: { textAlign: 'start', minHeight: '0' },
      bodyStyle: {
        height: '21.3rem',
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
      },
      class: "graph-builder-v3-card"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            (_ctx.header?.titlePrefixIcon)
              ? (_openBlock(), _createBlock(_component_BaseIcon, {
                  key: 0,
                  name: _ctx.header?.titlePrefixIcon,
                  width: "1em",
                  height: "1em",
                  class: "header-icon-preifx"
                }, null, 8, ["name"]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.title) + " ", 1),
            (_ctx.header?.titleSuffixIcon)
              ? (_openBlock(), _createBlock(_component_BaseIcon, {
                  key: 1,
                  name: _ctx.header?.titleSuffixIcon,
                  class: "header-icon-suffix",
                  width: "1rem",
                  height: "1rem"
                }, null, 8, ["name"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(GraphCardHeaders, {
            header: _ctx.header,
            childQuery: _unref(headerValues)
          }, null, 8, ["header", "childQuery"]),
          _createVNode(GraphCardActionsV3, {
            title: _ctx.title,
            handleZoomOut: _unref(handleZoomOut),
            handleZoomIn: _unref(handleZoomIn),
            handleReset: _unref(handleReset),
            displayExpand: displayExpand.value,
            metricName: _ctx.metricName,
            params: _ctx.params,
            serviceName: _ctx.serviceName,
            axisLabels: _ctx.axisLabels,
            aggregation: aggregation.value
          }, null, 8, ["title", "handleZoomOut", "handleZoomIn", "handleReset", "displayExpand", "metricName", "params", "serviceName", "axisLabels", "aggregation"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(MultiChartV3, {
          ref_key: "multiChart",
          ref: multiChart,
          series: _unref(data),
          chartOptions: _unref(options),
          type: _ctx.type
        }, null, 8, ["series", "chartOptions", "type"])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})